import Vue from "vue";
import Gravatar from "vue-gravatar";
import moment from "moment";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "@fortawesome/fontawesome-pro/css/all.css";
import "@/assets/css/tailwind.css";
import "@/assets/css/app.scss";
import "nprogress/nprogress.css";

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn:
      "https://12e232f5f8d31ce68e3d85ebf732c456@o106432.ingest.sentry.io/4506031700770817",
    integrations: [new Integrations.Vue({ Vue })],
    environment: process.env.NODE_ENV,
    release: process.env.VUE_APP_SENTRY_RELEASE
  });
} else {
  // You may remove this once you are sure everything works fine
  console.debug("Not configuring Sentry, environment is", process.env.NODE_ENV);
}

Vue.config.productionTip = false;

Vue.component("v-gravatar", Gravatar);

Vue.filter("formatDate", function(strFecha, formato) {
  formato = formato || "DD MMM YYYY";
  return moment(strFecha).format(formato);
});

Vue.filter("prettyNumber", function(value, style) {
  const formatter = new Intl.NumberFormat("es-CL", {
    style,
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

window.EventBus = new Vue();
window.CentralStore = store;

moment.locale("es");

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
